import { People } from '@mui/icons-material';
import AutoAwesomeMosaicOutlinedIcon from '@mui/icons-material/AutoAwesomeMosaicOutlined';
import Tabs from '/@/components/bayer/tabs';
import { _ } from '/@/locale';
import type { FieldSelectTab } from './use-field-select';

function FieldSelectTabs({ tab, setTab }: { tab: FieldSelectTab; setTab: (tab: FieldSelectTab) => void }) {
    return (
        <Tabs
            options={[
                {
                    label: _('Productores'),
                    value: 'growers',
                    icon: <People color={tab === 'growers' ? 'secondary' : 'primary'} sx={{ fontSize: 16 }} />,
                },
                {
                    label: _('Mis lotes'),
                    value: 'my-fields',
                    icon: (
                        <AutoAwesomeMosaicOutlinedIcon
                            color={tab === 'my-fields' ? 'secondary' : 'primary'}
                            sx={{ fontSize: 16 }}
                        />
                    ),
                },
            ]}
            value={tab}
            setValue={(value) => setTab(value as FieldSelectTab)}
        />
    );
}

export default FieldSelectTabs;
